import React, { useState } from "react";
import {
    PROPERTY_TYPES,
    TRANSACTION_TYPES,
    PROPERTY_AMENITIES,
    FURNITURE_OPTIONS,
    HANDOVER_OPTIONS,
    PROPERTY_STATUS_OPTIONS,
} from "../../../constants/admin/property/propertyConstants";

import {
    validatePropertyForm,
} from "../../../utils/admin/propertyValidation";

import {
    handleProjectChange,
    toggleAmenity,
} from "../../../utils/admin/propertyFormHelpers";

import PropertyImagePreview from "./PropertyImagePreview";

const PropertyForm = ({
    formData,
    handleChange,
    handleImageChange,
    handleSubmit,
    editingProperty,
    imageFiles,
    handleRemoveImage,
    projects
}) => {
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);


    const onSubmit = async (e) => {
        e.preventDefault();
        const validationErrors =
            validatePropertyForm(
                formData,
                imageFiles,
                editingProperty
            );

        setErrors(validationErrors);

        if (
            Object.keys(validationErrors)
                .length > 0
        ) {
            return;
        }

        try {
            setIsSubmitting(true);

            await handleSubmit();
        } finally {
            setIsSubmitting(false);
        }
    };


    return (
        <div className="bg-gray-100 dark:bg-gray-800 p-4 rounded space-y-4">
            <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mb-2">
                {editingProperty ? "Cập nhật tin bất động sản" : "Đăng tin bất động sản mới"}
            </h2>

            <form onSubmit={onSubmit} className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {/* Dự án */}
                    <div>
                        <label className="block font-medium text-gray-700 dark:text-gray-200">Dự án</label>
                        <select
                            name="projectId"
                            value={formData.projectId}
                            onChange={(e) =>
                                handleProjectChange(
                                    e,
                                    projects,
                                    handleChange
                                )
                            }
                            className="mt-1 w-full border rounded px-3 py-2 bg-white dark:bg-gray-700 dark:text-white"
                        >
                            <option value="">-- Chọn dự án --</option>
                            {projects.map(p => (
                                <option key={p.id} value={p.id}>
                                    {p.name}
                                </option>
                            ))}
                        </select>
                        {errors.projectId && <p className="text-red-500 text-sm">{errors.projectId}</p>}
                    </div>


                    {/* Tiêu đề */}
                    <div>
                        <label className="block font-medium text-gray-700 dark:text-gray-200">Tiêu đề</label>
                        <input
                            type="text"
                            name="title"
                            value={formData.title}
                            onChange={handleChange}
                            className="mt-1 w-full border rounded px-3 py-2 bg-white dark:bg-gray-700 dark:text-white"
                        />
                        {errors.title && <p className="text-red-500 text-sm">{errors.title}</p>}
                    </div>

                    {/* Loại bất động sản */}
                    <div>
                        <label className="block font-medium text-gray-700 dark:text-gray-200">Loại bất động sản</label>
                        <select
                            name="propertyType"
                            value={formData.propertyType}
                            onChange={handleChange}
                            className="mt-1 w-full border rounded px-3 py-2 bg-white dark:bg-gray-700 dark:text-white"
                        >
                            <option value="">-- Chọn loại --</option>
                            {PROPERTY_TYPES.map((type) => (
                                <option key={type.value} value={type.value}>
                                    {type.label}
                                </option>
                            ))}
                        </select>
                        {errors.propertyType && <p className="text-red-500 text-sm">{errors.propertyType}</p>}
                    </div>
                    {/* Loại giao dịch */}
                    <div>
                        <label className="block font-medium text-gray-700 dark:text-gray-200">
                            Loại giao dịch
                        </label>
                        <select
                            name="transactionType"
                            value={formData.transactionType || "sale"}
                            onChange={handleChange}
                            className="mt-1 w-full border rounded px-3 py-2"
                        >
                            {TRANSACTION_TYPES.map((type) => (
                                <option key={type.value} value={type.value}>
                                    {type.label}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Giá bán (nếu chọn sale) */}
                    {formData.transactionType === "sale" && (
                        <div className="mt-2">
                            <label className="block font-medium text-gray-700 dark:text-gray-200">
                                Giá bán (VND)
                            </label>
                            <input
                                type="number"
                                name="price"
                                value={formData.price || ""}
                                onChange={handleChange}
                                min="0"
                                className="mt-1 w-full border rounded px-3 py-2"
                            />
                            {errors.price && <p className="text-red-500 text-sm">{errors.price}</p>}
                        </div>
                    )}

                    {/* Giá thuê (nếu chọn rent) */}
                    {formData.transactionType === "rent" && (
                        <div className="mt-2">
                            <label className="block font-medium text-gray-700 dark:text-gray-200">
                                Giá thuê (VND)
                            </label>
                            <input
                                type="number"
                                name="rentPrice"
                                value={formData.rentPrice || ""}
                                onChange={handleChange}
                                min="0"
                                className="mt-1 w-full border rounded px-3 py-2"
                            />
                            {errors.rentPrice && (
                                <p className="text-red-500 text-sm">{errors.rentPrice}</p>
                            )}
                        </div>
                    )}

                    {/* Block */}
                    <div>
                        <label className="block font-medium text-gray-700 dark:text-gray-200">Block / Phân khu</label>
                        <input
                            type="text"
                            name="block"
                            value={formData.block}
                            onChange={handleChange}
                            className="mt-1 w-full border rounded px-3 py-2 bg-white dark:bg-gray-700 dark:text-white"
                        />
                    </div>

                    {/* Unit code */}
                    <div>
                        <label className="block font-medium text-gray-700 dark:text-gray-200">Mã căn / Unit code</label>
                        <input
                            type="text"
                            name="unitCode"
                            value={formData.unitCode}
                            onChange={handleChange}
                            className="mt-1 w-full border rounded px-3 py-2 bg-white dark:bg-gray-700 dark:text-white"
                        />
                    </div>

                    {/* Tầng */}
                    <div>
                        <label className="block font-medium text-gray-700 dark:text-gray-200">Tầng</label>
                        <input
                            type="number"
                            name="floor"
                            value={formData.floor}
                            onChange={handleChange}
                            min="1"
                            className="mt-1 w-full border rounded px-3 py-2 bg-white dark:bg-gray-700 dark:text-white"
                        />
                    </div>

                    {/* Phòng ngủ / phòng tắm */}
                    <div>
                        <label className="block font-medium text-gray-700 dark:text-gray-200">Phòng ngủ</label>
                        <input
                            type="number"
                            name="bedrooms"
                            value={formData.bedrooms}
                            onChange={handleChange}
                            min="0"
                            className="mt-1 w-full border rounded px-3 py-2"
                        />
                    </div>
                    <div>
                        <label className="block font-medium text-gray-700 dark:text-gray-200">Phòng tắm</label>
                        <input
                            type="number"
                            name="bathrooms"
                            value={formData.bathrooms}
                            onChange={handleChange}
                            min="0"
                            className="mt-1 w-full border rounded px-3 py-2"
                        />
                    </div>

                    {/* Diện tích */}
                    <div>
                        <label className="block font-medium text-gray-700 dark:text-gray-200">Diện tích (m²)</label>
                        <input
                            type="number"
                            name="area"
                            value={formData.area}
                            onChange={handleChange}
                            min="0"
                            className="mt-1 w-full border rounded px-3 py-2"
                        />
                        {errors.area && <p className="text-red-500 text-sm">{errors.area}</p>}
                    </div>

                    {/* Nội thất */}
                    <div>
                        <label className="block font-medium text-gray-700 dark:text-gray-200">Tình trạng nội thất</label>
                        <select
                            name="furniture"
                            value={formData.furniture}
                            onChange={handleChange}
                            className="mt-1 w-full border rounded px-3 py-2"
                        >
                            {FURNITURE_OPTIONS.map((item) => (
                                <option key={item.value} value={item.value}>
                                    {item.label}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Bàn giao */}
                    <div>
                        <label className="block font-medium text-gray-700 dark:text-gray-200">Tình trạng bàn giao</label>
                        <select
                            name="handoverStatus"
                            value={formData.handoverStatus}
                            onChange={handleChange}
                            className="mt-1 w-full border rounded px-3 py-2"
                        >
                            {HANDOVER_OPTIONS.map((item) => (
                                <option key={item.value} value={item.value}>
                                    {item.label}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Tình trạng tin */}
                    <div>
                        <label className="block font-medium text-gray-700 dark:text-gray-200">Trạng thái tin</label>
                        <select
                            name="status"
                            value={formData.status}
                            onChange={handleChange}
                            className="mt-1 w-full border rounded px-3 py-2"
                        >
                            {PROPERTY_STATUS_OPTIONS.map((item) => (
                                <option key={item.value} value={item.value}>
                                    {item.label}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Đã bán chưa */}
                    <div className="flex items-center space-x-4">
                        <label className="block font-medium text-gray-700 dark:text-gray-200">Trạng thái bán</label>
                        <div className="flex gap-3">
                            <label>
                                <input
                                    type="radio"
                                    name="isSold"
                                    value="false"
                                    checked={!formData.isSold}
                                    onChange={(e) => handleChange({ target: { name: "isSold", value: e.target.value === "true" } })}
                                />
                                <span className="ml-1">Chưa bán</span>
                            </label>
                            <label>
                                <input
                                    type="radio"
                                    name="isSold"
                                    value="true"
                                    checked={formData.isSold}
                                    onChange={(e) => handleChange({ target: { name: "isSold", value: e.target.value === "true" } })}
                                />
                                <span className="ml-1">Đã bán</span>
                            </label>
                        </div>
                    </div>

                    {/* Vị trí */}
                    <div className="md:col-span-2">
                        <label className="block font-medium text-gray-700 dark:text-gray-200">Vị trí</label>
                        <input
                            type="text"
                            name="location"
                            value={formData.location}
                            onChange={handleChange}
                            className="mt-1 w-full border rounded px-3 py-2"
                        />
                        {errors.location && <p className="text-red-500 text-sm">{errors.location}</p>}
                    </div>
                </div>

                {/* Tiện ích */}
                <div>
                    <label className="block font-medium text-gray-700 dark:text-gray-200">Tiện ích</label>
                    <div className="flex gap-2 flex-wrap mt-1">
                        {PROPERTY_AMENITIES.map((amenity) => (
                            <label key={amenity} className="flex items-center gap-1">
                                <input
                                    type="checkbox"
                                    checked={formData.amenities.includes(amenity)}
                                    onChange={() =>
                                        toggleAmenity(
                                            amenity,
                                            formData.amenities,
                                            handleChange
                                        )
                                    }
                                />
                                {amenity}
                            </label>
                        ))}
                    </div>
                </div>
                {/* Mô tả */}
                <div>
                    <label className="block font-medium text-gray-700 dark:text-gray-200">Mô tả chi tiết</label>
                    <textarea
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                        className="mt-1 w-full border rounded px-3 py-2 h-24"
                    />
                </div>

                {/* Ảnh */}
                <div>
                    <label className="block font-medium text-gray-700 dark:text-gray-200">Hình ảnh</label>
                    <input
                        type="file"
                        multiple
                        accept="image/*"
                        onChange={handleImageChange}
                        className="mt-1 dark:text-gray-200"
                    />
                    {errors.images && <p className="text-red-500 text-sm">{errors.images}</p>}

                    <PropertyImagePreview
                        imageFiles={imageFiles}
                        editingProperty={editingProperty}
                        images={formData.images}
                        onRemove={handleRemoveImage}
                    />
                </div>

                <button
                    type="submit"
                    disabled={isSubmitting}
                    className={`px-6 py-2 rounded text-white ${isSubmitting ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"
                        }`}
                >
                    {isSubmitting
                        ? (editingProperty ? "Đang cập nhật..." : "Đang đăng tin...")
                        : (editingProperty ? "Cập nhật" : "Đăng tin")}
                </button>
            </form>
        </div>
    );
};

export default PropertyForm;
